(() => {
  'use strict';

  // 技术参数轮播(移动端)。
  // 滑动由 CSS scroll-snap 原生完成, JS 只做圆点同步、点击跳转、键盘左右键。
  const init = (scope = document) => {
    scope.querySelectorAll('[data-technische-daten]').forEach((root) => {
      if (root.dataset.technischeDatenReady === 'true') return;
      root.dataset.technischeDatenReady = 'true';

      const track = root.querySelector('[data-technische-daten-track]');
      const dotsWrap = root.querySelector('[data-technische-daten-dots]');
      if (!track || !dotsWrap) return;

      const slides = Array.from(track.children);
      if (slides.length < 2) {
        dotsWrap.remove();
        return;
      }

      const dots = slides.map((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-technische-daten__dot';
        dot.setAttribute('aria-label', `${index + 1} / ${slides.length}`);
        dot.addEventListener('click', () => {
          track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.append(dot);
        return dot;
      });

      const setActive = (index) => {
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      };
      setActive(0);

      // 滑到哪张, 哪张的圆点变胶囊(阈值 0.6 = 过半即切换)
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(slides.indexOf(entry.target));
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach((slide) => observer.observe(slide));

      // 键盘可达性: 焦点在轮播上时左右键翻页
      track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        const current = slides.findIndex(
          (slide) => Math.abs(slide.offsetLeft - track.scrollLeft) < slide.offsetWidth / 2
        );
        const next = event.key === 'ArrowRight' ? current + 1 : current - 1;
        if (next >= 0 && next < slides.length) {
          event.preventDefault();
          track.scrollTo({ left: slides[next].offsetLeft, behavior: 'smooth' });
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
